import { DictionariesEditPage } from 'features/dictionaries/components/DictionariesEditPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesVehicleEditPage = () => {
  return <DictionariesEditPage type={DictionaryType.Vehicle} />
}
